import { useAuthStore } from '../../stores';
import { WithErrorBoundary } from '@bloomays-lib/ui.shared';
import LoginForm from '../organisms/LoginForm';
import { Navigate } from 'react-router-dom';

const LoginFormBloomers = () => {
  const auth = useAuthStore((state) => state.auth);
  if (auth && auth.isAuthenticated) {
    return (<Navigate to="/" />) as React.ReactNode;
  }
  return (<LoginForm />) as React.ReactNode;
};

export default WithErrorBoundary(LoginFormBloomers);
